/**
 * Buying USDC with a card or bank, through MoonPay.
 *
 * A plain link to MoonPay's public USDC page: no partner key, no wallet
 * address and no signature in it, so nothing secret exists in the app or on
 * the box. The person copies their own address and pastes it in MoonPay
 * themselves. A keyed partner link can replace this one constant later
 * without touching the screens.
 */
export const MOONPAY_BUY_URL = 'https://www.moonpay.com/buy/usdc';
